export function formatSeconds(seconds: number) {
  if(!seconds) {
    return "00:00:00"
  }
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = pad(date.getUTCSeconds());
    // const decinals = pad(Math.floor((seconds % 1) * 100));

    return `${pad(hh)}:${pad(mm)}:${ss}`;
    // return `${pad(hh)}:${pad(mm)}:${ss}.${decinals}`;
    // if (hh) {
    //   return `${pad(hh)}:${pad(mm)}:${ss}.${decinals}`;
    // }
    // return `${pad(mm)}:${ss}.${decinals}`;
  }
  
  function pad(string: string | number) {
    return (`0${string}`).slice(-2);
  }
  
  